/**
 * Created by Kaku.Guo on 2018/10/26.
 */
import React from 'react';
import {withRouter} from 'react-router';
import qs from 'query-string';
import {connect} from 'react-redux';
import Helmet from 'react-helmet';
import {BasePageView, mapStateToProps, mapDispatchToProps} from '../index';
import {getMessage} from '../../components';
import {getHelmetMetaTags} from '../../utils/metaTagUtils';

@connect(mapStateToProps, mapDispatchToProps)
class AssetsView extends BasePageView {
    constructor(props) {
        super(props, null, {
            extraFilter: ['keywords'],
            isAssetsPage: true,
            pageTitleCode: 'messages.com.epicgames.plugin.store.title.search'
        });
    }

    componentDidMount() {
        const listParams = this.state.listParams || {};
        const {keywords} = listParams;
        this.setPageConfig(keywords);
        super.componentDidMount();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        super.UNSAFE_componentWillReceiveProps(nextProps);
        const location = nextProps.location || {};
        const {search} = location;
        const searchParams = qs.parse(search);
        const keywords = searchParams.keywords || '';
        const listParams = this.state.listParams || {};
        const oldKeywords = listParams.keywords || '';
        if (keywords !== oldKeywords) {
            this.setPageConfig(keywords);
        }
    }

    componentWillUnmount() {
        this.props.setConfig({
            keywords: ''
        });
    }

    setPageConfig = keywords => {
        const contentHeader = {
            code: 'messages.com.epicgames.plugin.store.assets.page.header'
        };
        if (keywords) {
            contentHeader.code = 'messages.com.epicgames.plugin.store.search.result.header';
            contentHeader.args = [keywords];
        }
        this.props.setConfig({
            contentHeader,
            keywords
        });
    };

    getHelmetElement = () => {
        const {helmet} = this.state;
        const listParams = this.state.listParams || {};
        const {tag} = listParams;
        const {messages, locale} = this.props;
        const pageTitle = helmet.title;
        let descriptionCode = null;
        const tagCode = tag ? tag[0] : null;
        switch (tagCode) {
            case '4910':
                descriptionCode = 'epic.ue.marketplace.meta.free_month';
                break;
            case '4906':
                descriptionCode = 'epic.ue.marketplace.meta.free_collection';
                break;
            default:
                descriptionCode = 'epic.ue.marketplace.meta.browse';
                break;
        }

        const helmetTags = getHelmetMetaTags({
            title: pageTitle,
            description: getMessage(messages, descriptionCode),
            locale
        });

        return <Helmet {...helmetTags} />;
    };
}
export default withRouter(AssetsView);
